import { useCallback } from "react";
import { useDispatch } from "react-redux";
//Local files
import { templatesActions } from 'features/templates';

const useTemplates = () => {
  const dispatch = useDispatch();
  const getTemplate = useCallback((id) => dispatch(templatesActions.getTemplate(id)), [dispatch]);
  const updateTemplate = useCallback(template => dispatch(templatesActions.updateTemplate(template)), [dispatch]);
  const deleteTemplate = useCallback(id => dispatch(templatesActions.deleteTemplate(id)), [dispatch]);

  return { 
    getTemplate, 
    updateTemplate, 
    deleteTemplate
  };
};

export default useTemplates;